export default __webpack_public_path__ + "static/media/create-post-icon-gray.e545da68.svg";